import DeviceStatusIcon from '../../../components/DeviceStatusIcon/DeviceStatusIcon';
import Devices from './Devices';
import { updateDeviceDTO, updateDeviceStatus } from './Devices.service';
import {
  CustomEventTypes,
  customEventAtom,
  devicesAtom,
  groupedDevicesAtom
} from './Devices.store';
import useStyles from './Devices.styles';

export {
  CustomEventTypes,
  customEventAtom,
  DeviceStatusIcon,
  devicesAtom,
  groupedDevicesAtom,
  updateDeviceDTO,
  updateDeviceStatus,
  useStyles
};

export default Devices;
